(() => {
  if (window.utmb26SwiperSection) {
    window.utmb26SwiperSection.init(document);
    return;
  }

  const getScale = () => window.innerWidth <= 749 ? window.innerWidth / 393 : window.innerWidth / 1920;
  const getSpaceBetween = () => 24 * getScale();

  const setup = (root) => {
    if (root.dataset.utmb26SwiperInitialized === "true" || typeof window.Swiper !== "function") return;

    const viewport = root.querySelector(".utmb26-swiper__viewport");
    const pagination = root.querySelector(".utmb26-swiper__pagination");
    const slides = root.querySelectorAll(".utmb26-swiper__slide");

    if (!viewport || slides.length === 0) return;

    const autoplayDelay = Math.max(1, Number(root.dataset.cycleDuration) || 5) * 1000;

    const swiper = new window.Swiper(viewport, {
      slidesPerView: "auto",
      spaceBetween: getSpaceBetween(),
      speed: 600,
      loop: slides.length > 1,
      loopedSlides: slides.length,
      grabCursor: true,
      watchOverflow: true,
      preventClicks: true,
      preventClicksPropagation: true,
      autoplay: {
        delay: autoplayDelay,
        disableOnInteraction: false,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
    });

    root.querySelectorAll(".utmb26-swiper__prev").forEach((button) => {
      button.addEventListener("click", () => swiper.slidePrev());
    });

    root.querySelectorAll(".utmb26-swiper__next").forEach((button) => {
      button.addEventListener("click", () => swiper.slideNext());
    });

    const pauseAutoplay = () => swiper.autoplay?.stop();
    const resumeAutoplay = () => swiper.autoplay?.start();

    root.addEventListener("mouseenter", pauseAutoplay);
    root.addEventListener("mouseleave", resumeAutoplay);
    root.addEventListener("focusin", pauseAutoplay);
    root.addEventListener("focusout", (event) => {
      if (!root.contains(event.relatedTarget)) resumeAutoplay();
    });

    const handleResize = () => {
      swiper.params.spaceBetween = getSpaceBetween();
      swiper.update();
    };

    window.addEventListener("resize", handleResize);
    root.utmb26Swiper = swiper;
    root.utmb26SwiperResize = handleResize;
    root.dataset.utmb26SwiperInitialized = "true";
  };

  const init = (root = document, attempts = 0) => {
    const sections = [];

    if (root.matches?.("[data-utmb26-swiper]")) sections.push(root);
    root.querySelectorAll?.("[data-utmb26-swiper]").forEach((section) => sections.push(section));

    if (typeof window.Swiper !== "function") {
      if (attempts < 30) {
        window.setTimeout(() => init(root, attempts + 1), 100);
      }
      return;
    }

    sections.forEach(setup);
  };

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector?.("[data-utmb26-swiper]");
    if (!root?.utmb26Swiper) return;

    window.removeEventListener("resize", root.utmb26SwiperResize);
    root.utmb26Swiper.destroy(true, true);
  });

  window.utmb26SwiperSection = { init };
  init();
})();
